import script from "./Vagas.vue?vue&type=script&lang=js"
export * from "./Vagas.vue?vue&type=script&lang=js"

import "./Vagas.vue?vue&type=style&index=0&id=363e0db4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-363e0db4"]])

export default __exports__